export const dashboardRoutePaths = {
  dashboard: '/dashboard',
}
